import { useEffect, useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import OtpInput from "react-otp-input";
import { Col, FormGroup, Input, Label, Modal, Row } from "reactstrap";

const OtpVerificationModal = ({
  modal,
  setModal,
  otp,
  setOtp,
  password,
  setPassword,
  loading,
  onClick,
  resendClick,
}) => {
  const [timePeriod, setTimePeriod] = useState({ minutes: 0, seconds: 59 });
  const [showPassword, setShowPassword] = useState(false);

  const toggle = () => {
    setModal(!modal);
    setPassword("");
    setOtp("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!loading) {
      onClick();
    }
  };

  const handleResend = () => {
    if (timePeriod?.seconds === 0 && timePeriod?.minutes === 0) {
      setTimePeriod({
        seconds: 59,
        minutes: 0,
      });
      resendClick();
    }
  };

  useEffect(() => {
    if (modal) {
      setTimePeriod({
        seconds: 59,
        minutes: 0,
      });
    }
    let timer = setInterval(() => {
      setTimePeriod((prev) => {
        if (!(prev?.seconds === 0 && prev?.minutes === 0)) {
          return {
            seconds: prev?.seconds === 0 ? 60 : prev?.seconds - 1,
            minutes: !prev?.seconds % 60 ? prev?.minutes - 1 : prev?.minutes,
          };
        } else {
          return {
            seconds: 0,
            minutes: 0,
          };
        }
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [modal]);

  return (
    <Modal isOpen={modal} toggle={toggle} centered>
      <div className="p-4">
        <form onSubmit={handleSubmit}>
          <FormGroup>
            <Row className="d-flex flex-column align-items-center">
              <Col xs="auto">
                <Label className="form-label text-center">
                  Please enter 4-digit OTP
                </Label>
              </Col>

              <Col xs="auto">
                <OtpInput
                  value={otp}
                  onChange={setOtp}
                  numInputs={4}
                  renderSeparator={<span>-</span>}
                  inputType="number"
                  renderInput={(props) => (
                    <input
                      {...props}
                      style={{
                        width: "40px",
                        height: "40px",
                        fontSize: "24px",
                        textAlign: "center",
                        border: "1px solid #CED4DA",
                        borderRadius: "4px",
                        margin: "0 5px 8px 5px",
                        outline: "none",
                      }}
                      onFocus={(e) => (e.target.style.borderColor = "#007bff")}
                      onBlur={(e) => (e.target.style.borderColor = "#CED4DA")}
                    />
                  )}
                />
              </Col>
            </Row>

            <div className="mb-3" style={{ position: "relative" }}>
              <Label className="form-label">Password</Label>
              <Input
                name="password"
                className="form-control"
                placeholder="Enter new password"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <span
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  cursor: "pointer",
                }}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
          </FormGroup>
          <p>OTP will expire in 5 minutes.</p>
          <p>
            You can resend OTP in {timePeriod?.minutes} : {timePeriod?.seconds}{" "}
            minute{" "}
            <span
              style={{
                fontWeight: "500",
                color: !(timePeriod?.seconds === 0 && timePeriod?.minutes === 0)
                  ? "#B4B6B6"
                  : "#8B0000",
                cursor: !(
                  timePeriod?.seconds === 0 && timePeriod?.minutes === 0
                )
                  ? "not-allowed"
                  : "pointer",
              }}
              onClick={handleResend}
            >
              Resend.
            </span>
          </p>

          <Row className="justify-content-end">
            <Col xs="auto">
              <button
                className="btn btn-danger w-md"
                type="button"
                onClick={toggle}
                disabled={loading}
              >
                Cancel
              </button>
            </Col>
            <Col xs="auto">
              <button
                className="btn btn-primary w-md"
                type="submit"
                disabled={loading}
              >
                {loading ? "Loading" : "Reset"}
              </button>
            </Col>
          </Row>
        </form>
      </div>
    </Modal>
  );
};

export default OtpVerificationModal;
